import jsPDF from 'jspdf'
const months = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  10: 'October',
  11: 'November',
  12: 'December',
}
const yearTens = {
  2: 'Twenty',
  3: 'Thirty',
  4: 'Forty',
  5: 'Fifty',
  6: 'Sixty',
  7: 'Seventy',
  8: 'Eighty',
  9: 'Ninety',
}
const yearOnes = {
  '00': '',
  '01': 'One',
  '02': 'Two',
  '03': 'Three',
  '04': 'Four',
  '05': 'Five',
  '06': 'Six',
  '07': 'Seven',
  '08': 'Eight',
  '09': 'Nine',
  10: 'Ten',
  11: 'Eleven',
  12: 'Twelve',
  13: 'Thirteen',
  14: 'Fourteen',
  15: 'Fifteen',
  16: 'Sixteen',
  17: 'Seventeen',
  18: 'Eighteen',
  19: 'Nineteen',
}
const days = {
  '01': 'First',
  '02': 'Second',
  '03': 'Third',
  '04': 'Fourth',
  '05': 'Fifth',
  '06': 'Sixth',
  '07': 'Seventh',
  '08': 'Eighth',
  '09': 'Ninth',
  10: 'Tenth',
  11: 'Eleventh',
  12: 'Twelfth',
  13: 'Thirteenth',
  14: 'Fourteenth',
  15: 'Fifteenth',
  16: 'Sixteenth',
  17: 'Seventeenth',
  18: 'Eighteenth',
  19: 'Nineteenth',
  20: 'Twentieth',
  21: 'Twenty First',
  22: 'Twenty Second',
  23: 'Twenty Third',
  24: 'Twenty Fourth',
  25: 'Twenty Fifth',
  26: 'Twenty Sixth',
  27: 'Twenty Seventh',
  28: 'Twenty Eighth',
  29: 'Twenty Ninth',
  30: 'Thirtieth',
  31: 'Thirty First',
}
/* const year={
    '1':'FE',
    '2':'SE',
    '3':'TE',
    '4':'BE',
  }*/
const generatePdf = data => {
  var doc = new jsPDF()
  doc.setFontSize(12)
  doc.line(5, 5, 205, 5)
  doc.line(205, 292, 205, 5) // horizontal line
  doc.line(5, 292, 205, 292)
  doc.line(5, 292, 5, 5)
  doc.line(10, 220, 200, 220)
  doc.text('LC Number- ' + data.lc_number, 20, 55)
  doc.text('SAP No. ' + data.sap_id, 180, 60, null, null, 'right')
  let formatArray = data.date_of_birth.split('-')
  let formattedDOB = formatArray[2] + '/' + formatArray[1] + '/' + formatArray[0]
  let dateFigure = ''
  dateFigure = dateFigure + days[formatArray[2]] + ' ' + months[formatArray[1]]
  let year1 = formatArray[0].substring(0, 2)
  let year2 = formatArray[0].substring(2, 4)
  if (year1[0] === '2') {
    dateFigure = dateFigure + ' Two Thousand'
  } else {
    dateFigure = dateFigure + ' Nineteen'
  }
  if (year2[0] === '0' || year2[0] === '1') {
    dateFigure = dateFigure + ' ' + yearOnes[year2]
  } else {
    dateFigure = dateFigure + ' ' + yearTens[year2[0]] + ' ' + yearOnes['0' + year2[1]]
  }
  formatArray = data.date_of_admission.split('-')
  let formattedDateAdmission = formatArray[2] + '/' + formatArray[1] + '/' + formatArray[0]
  //let yearOfAdmission=formatArray[0];
  formatArray = data.date_of_leaving.split('-')
  let formattedDateLeaving = formatArray[2] + '/' + formatArray[1] + '/' + formatArray[0]
  const name = data.last_name + ' ' + data.first_name + ' ' + data.father_name + ' ' + data.mother_name
  const rel = data.religion + '  ' + data.sub_caste
  const course = data.degree + ' in ' + data.course + ' '
  doc.autoTable({
    startY: 64,
    showHead: 'firstPage',
    body: [
      ['1.    Name of the Student\n       [beginning with surname]', name],
      ['2.    Religion / Caste with Sub-Caste', rel],
      ['3.    Nationality', data.nationality],
      ['4.    Place of Birth', data.place_of_birth],
      ['5.    Date of Birth\n       [both in words and figures]', formattedDOB + '\n' + dateFigure],
      // ['', dateFigure],
      ['6.    Last School / College Attended', data.prev_college],
      ['7.    Date of Admission to College', formattedDateAdmission],
      ['8.    Progress', data.progress],
      ['9.    Conduct', data.conduct],
      ['10.  Date of Leaving / Transfer', formattedDateLeaving],
      ['11.  Course and Year / Semester in\n       which studying and since when', course],
      ['12.  Reason for Leaving / Transfer', data.reason_for_leaving],
      ['13.  Remarks', 'Nil'],
    ],
    rowPageBreak: 'auto',
    bodyStyles: {
      valign: 'top',
    },
    styles: {
      fontSize: 12,
    },
    columnStyles: {
      0: {
        cellWidth: 80,
      },
      1: {
        cellWidth: 90,
      },
    },
    theme: 'plain',
  })
  doc.setFontSize(10)
  doc.text('Certified that the above information is in accordance with the college Register', 20, 225)
  doc.text('Received Rs. 100/-', 20, 230)
  doc.text('Place : Mumbai', 20, 235)
  doc.text('Date _____________  Prepared By _____________  Checked by ____________  PRINCIPAL', 20, 248)
  doc.text(
    'N.B.: No change in any entry in this certificate shall be made except by authority issuing it and any infringement',
    20,
    258
  )
  doc.text(' of this requirment is liable to involve the imposition penalty such as that of rustification', 20, 262)

  doc.save(`${data.sap_id}_LC.pdf`)
}

export default generatePdf
